const data = [
   
   {
      image:"/img/SOSOMIRA.png",
      title: "SOSOMIRA",
      link:'https://sosomira.vercel.app/',
      skill: [
         "/img/skill/React-Light.svg",
         "/img/skill/NodeJS-Light.svg",
         "/img/skill/Sass.svg",
         "/img/skill/JavaScript.svg",
      ],
      personnel: 2,
      part: "프론트전반 서버구축 호스팅",
      desTitle: "REACT 기반으로 만든 창작 사이트입니다.",
      des: "node.js사용해 서버를 구축하였고, 데이터베이스와 연동하여 업로드 기능과 회원가입 로그인 기능을 구현하였습니다. 그리고 버셀과 클라우드타입을 이용하여 배포하였습니다.",
   },
   {
      image:"/img/NEXTPROJECT.png",
      title: "VIVID",
      link:'https://next-project-pi-eight.vercel.app/',
      skill: [
         "/img/skill/React-Light.svg",
         "/img/skill/NextJS-Light.svg",
         "/img/skill/Sass.svg",
         "/img/skill/JavaScript.svg",
      ],
      personnel: 1,
      part: "프론트전반",
      desTitle: "NEXT를 사용해 처음으로 만든 사이트입니다.",
      des: "넥스트와 버셀 몽고DB를 활용하여 회원가입, 로그인, 댓글, 문의, 카트 기능을 구현하였습니다.",
   },

   {
      image:"/img/MOVIE.png",
      title: "MOVI",
      link:'https://movie-project-tawny.vercel.app/',
      skill: [
         "/img/skill/React-Light.svg",
         "/img/skill/Sass.svg",
         "/img/skill/JavaScript.svg",
      ],
      personnel: 1,
      part: "프론트전반",
      desTitle: "API 를 활용하여 만든 영화 사이트입니다.",
      des: "API와 데이터 학습을 위해 API를 통해 데이터를 불러오고 배치해서 사용한 사이트입니다.",
   },
   {
      image:'/img/PRINTBAYKERY.png',
      title: "FRINT BAYKERY",
      link:'https://sin-still.github.io/project02/',
      skill: [
         "/img/skill/HTML.svg",
         "/img/skill/Sass.svg",
         "/img/skill/JQuery.svg",
         "/img/skill/JavaScript.svg",
      ],
      personnel: 1,
      part: "프론트전반",
      desTitle: "첫 반응형 클론코딩 프로젝트입니다",
      des: "반응형의 기초를 다듬고 flex 를 사용해 제작하였습니다. 페이지새로고침시 랜덤으로 이미지가 바뀌는 로직을 구현하였습니다. ",
   },
   {
      image:'/img/KOREA.png',
      title: "한국에너지기술연구원",
      link:'https://sin-still.github.io/project01/',
      skill: [
         "/img/skill/HTML.svg",
         "/img/skill/CSS.svg",
         "/img/skill/JQuery.svg",
         "/img/skill/JavaScript.svg",
      ],
      personnel: 1,
      part: "프론트전반",
      desTitle: "코딩을 접하고 처음 만든 관공서 클론코딩 사이트 입니다",
      des: "탭 기능과 슬라이드를 직접 자바스크립트와 제이쿼리를 사용하여 구현하였습니다",
   },
]

export default data